import { render } from "./Thinking2.vue?vue&type=template&id=42618e3b"
import script from "./Thinking2.vue?vue&type=script&lang=js"
export * from "./Thinking2.vue?vue&type=script&lang=js"

import exportComponent from "/builds/skilltech-ph/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__